<!--
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-04-20 17:12:24
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" tableId="fbuPartnerFollowRecord" @fetch="fetch" ref="table">
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.dataIndex === 'content'">
        <a-button type="link" :title="text" @click="handleDetail(record)">{{ text }}</a-button>
      </template>
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleEdit(record)" v-permission="'fbu_partner_maintain_edit_btn'">
          编辑
        </a-button>
        <a-button type="link" @click="handleDelete(record)" v-permission="'fbu_partner_maintain_del_btn'">
          删除
        </a-button>
      </template>
    </template>
  </cos-table>
  <partnerFollowRecordFrom ref="partnerFollowRecordFromRef" @success="success" :disabled="disabled" />
  <cos-footer-button :loading="loading" returnName="DcCosZbuPartnerManage">
    <a-button type="primary" @click="handleAdd()" :loading="loading" v-permission="'fbu_partner_maintain_add_btn'"
      >新增维护记录</a-button
    >
  </cos-footer-button>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import { partnerFollowRecordList, partnerFollowRecordDelete } from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import type { PartnerManage } from '@/typings/api/marketingManage'
import partnerFollowRecordFrom from './partnerFollowRecordFrom.vue'
const route = useRoute()
const table = ref()
const loading = ref(false)
const partnerFollowRecordFromRef = ref()
defineProps({
  edit: {
    type: Boolean,
    default: false
  }
})
const disabled = ref(false)
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.id) {
    partnerFollowRecordList({
      partnerId: route.query.id,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
// 新增
const handleAdd = () => {
  disabled.value = false
  partnerFollowRecordFromRef.value.toggle({
    partnerName: route.query.name,
    partnerId: route.query.id
  })
}
// 查看
const handleDetail = (row: PartnerManage['partnerContact']) => {
  disabled.value = true
  partnerFollowRecordFromRef.value.toggle({
    ...row,
    partnerName: route.query.name,
    partnerId: route.query.id
  })
}
// 编辑
const handleEdit = (row: PartnerManage['partnerContact']) => {
  disabled.value = false
  partnerFollowRecordFromRef.value.toggle({
    ...row,
    partnerName: route.query.name,
    partnerId: route.query.id
  })
}
// 删除
const handleDelete = (row: PartnerManage['partnerContact']) => {
  Modal.delete({
    onOk() {
      partnerFollowRecordDelete({ id: row.id }).then((res) => {
        table.value.delFetch()
        message.success('删除成功')
      })
    }
  })
}
const success = (type?: 'add' | 'edit') => {
  if (type === 'add') {
    table.value.search()
  } else {
    table.value.fetch()
  }
}
const columns = ref([
  {
    title: '对接人',
    dataIndex: 'partnerContactName'
  },
  {
    title: '维护时间',
    dataIndex: 'followTime'
  },
  {
    title: '具体内容',
    dataIndex: 'content'
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 200
  }
])
</script>
<script lang="ts">
export default { name: 'PartnerActivity' }
</script>
<style lang="scss" scoped></style>
